// ------------------ Cart Remove Button ------------------
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

// ------------------ Cart Items ------------------
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    const debouncedOnChange = debounce((event) => this.onChange(event), 300);
    this.addEventListener('change', debouncedOnChange);
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe('cartUpdate', (event) => {
      if (event.source !== 'cart-items') this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value);
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then(res => res.text())
      .then(htmlText => {
        const html = new DOMParser().parseFromString(htmlText, 'text/html');
        const source = html.querySelector('cart-items');
        if (source) this.innerHTML = source.innerHTML;
      });
  }

  getSectionsToRender() {
    return [
      { id: 'main-cart-items', section: document.getElementById('main-cart-items').dataset.id, selector: '.js-contents' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
    ];
  }

  updateQuantity(line, quantity) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(s => s.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
      .then(res => res.json())
      .then(cart => updateShippingProgress(cart.total_price));
  }
}

customElements.define('cart-items', CartItems);

// // ------------------ Shipping Progress Bar ------------------
// function updateShippingProgress(totalPrice) {
//   const wrapper = document.querySelector('.cart-shipping-wrapper');
//   if (!wrapper) return;

//   const progressBar = wrapper.querySelector('.progress-bar-done');
//   const message = wrapper.querySelector('.shipping-message');
//   const icon = wrapper.querySelector('.free-shipping-icon');
//   const threshold = parseInt(document.getElementById('cart-shipping-bar').dataset.shippingThreshold) || 25000;

//   const percent = Math.min((totalPrice / threshold) * 100, 100);
//   const remaining = threshold - totalPrice;

//   progressBar.style.width = percent + '%';

//   if (remaining > 0) {
//     message.textContent = `You are ${Shopify.formatMoney(remaining)} away from free shipping!`;
//     icon?.classList.remove('iconicion');
//   } else {
//     message.textContent = '🎉 لديك شحن مجاني!';
//     icon?.classList.add('iconicion');
//   }
// }

// // Initialize on page load
// document.addEventListener('DOMContentLoaded', () => {
//   fetch('/cart.js')
//     .then(res => res.json())
//     .then(cart => { if (cart.total_price) updateShippingProgress(cart.total_price); });
// });
